export enum PixKeyType {
	PHONE = 'PHONE',
	CPF = 'CPF',
	CNPJ = 'CNPJ',
	EMAIL = 'EMAIL',
	EVP = 'EVP',
	MANUAL = 'MANUAL'
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/key-type.enum.ts